import { Pipe, PipeTransform } from '@angular/core';
import { translate } from "@ngneat/transloco";
import { FileTypeGroup } from "../_models/library/file-type-group.enum";

@Pipe({
  name: 'fileTypeGroup',
  standalone: true
})
export class FileTypeGroupPipe implements PipeTransform {

  transform(value: FileTypeGroup): string {
    switch (value) {
      case FileTypeGroup.Archive:
        return translate('file-type-group-pipe.archive');
      case FileTypeGroup.Epub:
        return translate('file-type-group-pipe.epub');
      case FileTypeGroup.Pdf:
        return translate('file-type-group-pipe.pdf');
      case FileTypeGroup.Images:
        return translate('file-type-group-pipe.image');
      case FileTypeGroup.Text:
        //return translate('file-type-group-pipe.text');
        return "Text";
    }
  }

}
